module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABN0lEQVQ4ja2TsUoDQRCGvzvTiIpoI0TiLd6ZYld8AG1FGwtrLXwLS42gtrEOaBe5N7CSw1cQkiYxpEl6CxuJjoV3MYZskoX8sPDvzj//DLuziAhBqJMg1GURYXgFoY6DUMeWWDkIdSIi5PjFJvDBaGjLOcBWmos/RuSE2RmpyJwDBeBQReZg2kQVmSKwC+RVZPZ94AbwgBzw4NDELbCS5lV8YG4gOO9gtDzAl3wgHji4duyol/ILT0RQkekAtXaz9ndHlx4AqqpfAdqn9R0ArqQvUZF5ArbbzVohm6Me8Dmi6trdXmc95XmgOxT/Ar6B/kDacH+s3ldTXgGObMJJc1S0cGejRwt3NiqdJRutk+fgDSiNE066I166i7bPPKVR9sxV839vwcw+bdZRC2hYNPUxBRvAAsAPPLRhy+fWjsEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y2.png
// module id = uHD+
// module chunks = 1